// extracted by css-extract-rspack-plugin
export default {"button":"_2f89dd80","inlineSpinner":"_8f78ae42"};